import React from "react";
import PropTypes from "prop-types";
import { Field } from "react-final-form";
import classNames from "classnames";

import { Bullet } from "../icons";
import "./FormRadio.css";

function FormRadio(props) {
  const {
    name,
    value,
    disabled,
    children,
    imageSrc,
    imageAlt,
    onClick,
    initialValue,
    className,
    validate,
    box,
  } = props;
  const id = `form-radio--${name}-${value}`;

  return (
    <label
      htmlFor={id}
      className={classNames("form-radio", className, {
        "form-radio--disabled": disabled,
      })}
    >
      <Field
        initialValue={initialValue}
        name={name}
        validate={validate}
        component="input"
        onClick={onClick}
        id={id}
        className={box ? "form-radio__box" : "form-radio__hidden"}
        type="radio"
        value={value}
      />

      {imageSrc ? (
        <div className="form-radio__image-container">
          <img
            className="form-radio__image"
            width="2.4rem"
            height="2.4rem"
            src={imageSrc}
            alt={imageAlt}
          />
        </div>
      ) : (
        !box && [
          <Bullet
            key={value + name}
            width="2.4rem"
            height="2.4rem"
            className="form-radio__dot"
          />,
          <div key={name + value} className="form-radio__styled" />,
        ]
      )}

      <span
        className={box ? "form-radio__caption--border" : "form-radio__caption"}
      >
        {children}
      </span>
    </label>
  );
}

FormRadio.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  required: PropTypes.bool,
};

FormRadio.defaultProps = {
  disabled: false,
  children: "",
  imageSrc: undefined,
  imageAlt: "",
  onChange() {},
  className: null,
  required: false,
};

export default FormRadio;



// WEBPACK FOOTER //
// ./src/components/form/FormRadio.js